import { render, staticRenderFns } from "./SidebarOne.vue?vue&type=template&id=1837df86&"
import script from "./SidebarOne.vue?vue&type=script&lang=js&"
export * from "./SidebarOne.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports